import React from "react";
import {
  CancelAction,
  Container,
  ContentContainer,
  ErrorMessage,
  MainAction,
} from "./styles";
import { CircularProgress } from "@material-ui/core";

export default function ActionsSection({
  isLoadingSubmit,
  errorMessage,
  isEditing = false,
  onCancel,
}) {
  return (
    <Container>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      <ContentContainer>
        <CancelAction onClick={onCancel} type="button">
          Cancelar
        </CancelAction>
        <MainAction type="submit" disabled={isLoadingSubmit}>
          {isLoadingSubmit ? (
            <>
              {isEditing ? "Atualizando" : "Cadastrando"}{" "}
              <CircularProgress size={16} style={{ color: "#fff" }} />
            </>
          ) : (
            isEditing ? "Finalizar Atualização" : "Finalizar Cadastro"
          )}
        </MainAction>
      </ContentContainer>
    </Container>
  );
}
